module.exports = __webpack_public_path__ + "images/icons/flags/PH-91bf4639.svg";